const { PodcastContext } = require('contexts/PodcastContext');
const { useContext } = require('react');

const usePodcast = () => useContext(PodcastContext);

export default usePodcast;
